import AuthenticatedResource  from 'resources/public/AuthenticatedResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class EventResource extends AuthenticatedResource {
  static urlRoot = '/admin/events'

  readonly id: number | undefined = undefined;
  
  pk() {
    return this.id?.toString();
  }
}